import { db } from '../firebase/config';
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';

const CONFIG_COLLECTION = 'assessmentConfig';
const ONBOARDING_DOC = 'onboarding';

export async function getOnboardingQuizConfig() {
  const ref = doc(db, CONFIG_COLLECTION, ONBOARDING_DOC);
  const snap = await getDoc(ref);
  if (!snap.exists()) return null;
  return snap.data();
}

export async function setOnboardingQuizConfig(config, adminId) {
  const ref = doc(db, CONFIG_COLLECTION, ONBOARDING_DOC);
  await setDoc(ref, {
    ...config,
    updatedAt: serverTimestamp(),
    updatedBy: adminId || 'ADMIN'
  }, { merge: true });
}

export default {
  getOnboardingQuizConfig,
  setOnboardingQuizConfig
};
